// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__T-i5E","name":"styles_name__1q94Z","phone":"styles_phone__fG3Sl"};